/**
 * Blog Infinite Scroll with Lazy Loading
 * Loads more articles as user scrolls, with lazy loading after 15 articles
 */
class BlogInfiniteScroll {
  constructor() {
    this.container = document.querySelector('.section-blog-posts');
    this.paginationContainer = document.querySelector('.pagination');
    
    if (!this.container) {
      console.log('Blog infinite scroll: Container not found');
      return;
    }
    
    if (!this.paginationContainer) {
      console.log('Blog infinite scroll: Pagination container not found');
      return;
    }
    
    this.nextLink = this.paginationContainer.querySelector('a[rel="next"]');
    
    // Fallback: look for next link in .next li
    if (!this.nextLink) {
      const nextLi = this.paginationContainer.querySelector('li.next a');
      if (nextLi) {
        this.nextLink = nextLi;
      }
    }
    
    if (!this.nextLink) {
      console.log('Blog infinite scroll: No next link found - only one page of articles');
      return;
    }
    
    console.log('Blog infinite scroll initialized with next link:', this.nextLink.href);
    
    this.loading = false;
    this.articleCount = this.container.querySelectorAll('li').length;
    this.lazyLoadThreshold = 15;
    
    this.init();
  }
  
  init() {
    // Hide the original pagination completely
    if (this.paginationContainer) {
      this.paginationContainer.style.display = 'none';
      this.paginationContainer.style.visibility = 'hidden';
      this.paginationContainer.style.opacity = '0';
      this.paginationContainer.style.height = '0';
      this.paginationContainer.style.overflow = 'hidden';
    }
    
    // Create loading indicator
    this.createLoadingIndicator();
    
    // Set up intersection observer for infinite scroll
    this.setupInfiniteScroll();
  }
  
  createLoadingIndicator() {
    this.loadingIndicator = document.createElement('div');
    this.loadingIndicator.className = 'blog-loading-indicator';
    this.loadingIndicator.style.cssText = 'text-align: center; padding: 2rem; display: none;';
    
    // Insert after the container instead of before pagination
    this.container.parentNode.insertBefore(this.loadingIndicator, this.container.nextSibling);
  }
  
  setupInfiniteScroll() {
    // Create a sentinel element at the bottom
    this.sentinel = document.createElement('div');
    this.sentinel.className = 'scroll-sentinel';
    this.sentinel.style.cssText = 'height: 1px; margin-top: -100px;';
    
    // Insert after the loading indicator
    if (this.loadingIndicator.nextSibling) {
      this.loadingIndicator.parentNode.insertBefore(this.sentinel, this.loadingIndicator.nextSibling);
    } else {
      this.loadingIndicator.parentNode.appendChild(this.sentinel);
    }
    
    // Set up intersection observer
    const options = {
      root: null,
      rootMargin: '200px',
      threshold: 0
    };
    
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.loading && this.nextLink) {
          this.loadMoreArticles();
        }
      });
    }, options);
    
    this.observer.observe(this.sentinel);
  }
  
  async loadMoreArticles() {
    if (this.loading || !this.nextLink) return;
    
    
    this.loading = true;
    
    try {
      const url = this.nextLink.href;
      const response = await fetch(url);
      const html = await response.text();
      
      // Parse the HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Get new articles
      const newArticles = doc.querySelectorAll('.section-blog-posts > li');
      
      console.log('Found', newArticles.length, 'new articles');
      
      // Append new articles
      newArticles.forEach((article, index) => {
        this.articleCount++;
        
        // Apply lazy loading to articles after the threshold
        if (this.articleCount > this.lazyLoadThreshold) {
          const images = article.querySelectorAll('img[src]');
          images.forEach(img => {
            // Convert to lazy loading
            if (!img.hasAttribute('loading')) {
              img.setAttribute('loading', 'lazy');
            }
          });
        }
        
        this.container.appendChild(article.cloneNode(true));
      });
      
      // Update next link
      const newPagination = doc.querySelector('.pagination a[rel="next"]');
      
      // Fallback: look for next link in .next li
      if (!newPagination) {
        const nextLi = doc.querySelector('.pagination li.next a');
        if (nextLi) {
          this.nextLink = nextLi;
        } else {
          this.nextLink = null;
        }
      } else {
        this.nextLink = newPagination;
      }
      
      if (!this.nextLink) {
        // No more pages
        this.observer.disconnect();
          this.loadingIndicator.style.display = 'none';
      } else {
        this.loadingIndicator.style.display = 'none';
      }
      
    } catch (error) {
      setTimeout(() => {
        this.loadingIndicator.style.display = 'none';
      }, 3000);
    } finally {
      this.loading = false;
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new BlogInfiniteScroll();
  });
} else {
  new BlogInfiniteScroll();
}
